/* eslint-disable multiline-ternary */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ReactElement, useEffect, useState } from 'react';
import {
  ContentHome,
  Nurse,
  Result,
  History,
  ServicesWrapper,
  Sidebar,
  ContentLayout,
  NextArrowDashboard,
  PrevArrowDashboard
} from './styles';
import Slider from '../../ui/Slider';
import Card from '../../ui/Card';
import MiniCard from '../../ui/MiniCard';
import Historic from '../../components/Historic';
import HelpCenter from '../../ui/Help';
import Schedule from '../../components/Schedule';

import NurseImg from '../../assets/nurse.svg';
import ResultsImg from '../../assets/results.svg';
import QuizImg from '../../assets/quizImg.png';
import HelpImage from '../../assets/help.svg';
import { useDispatch, useSelector } from 'react-redux';

import {
  ScheduleRootState,
  UserInfo,
  USER_PRODUCT,
  IS_USER_DATA_STALE
} from '../../store/redux';
import { GetListDependents } from '../../utils/services';
import ContactNurse from '../../components/ContactNurse';

export default function Dashboard(): ReactElement {
  const dispatch = useDispatch();
  const user: UserInfo = useSelector<ScheduleRootState, UserInfo>(
    (scheduleReducer) => scheduleReducer.user
  );
  const isUserDataStale = useSelector<ScheduleRootState, boolean>(
    (scheduleReducer) => scheduleReducer.isUserDataStale
  );
  const [contactNurse, setContactNurse] = useState(false);

  const [width, setWindowWidth] = useState(0);
  const showDesktopComponent: boolean = width > 1024;

  // Responsive
  const updateDimensions = () => {
    const width = window.outerWidth;
    setWindowWidth(width);
  };

  useEffect(() => {
    updateDimensions();

    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 0,
    nextArrow: <NextArrowDashboard className="next-arrow" />,
    prevArrow: <PrevArrowDashboard className="prev-arrow" />,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const localStorageToRedux = () => {
    const localUser = JSON.parse(localStorage.getItem('user') ?? '[]');
    if (localUser.length > 0) {
      dispatch({
        type: USER_PRODUCT,
        name: localUser.firstName,
        param: localUser.planDescription,
        lastName: localUser.lastName,
        prontuario: localUser.medicalRecord,
        state: {
          user: {
            eligibility: localUser?.eligibility,
            phone: localUser.phone,
            email: localUser.email,
            birthDate: localUser.birthDate,
            sex: localUser.sex,
            document: localUser.document,
            nationality: localUser.nationality,
            questionnaire: localUser.sendQuestionnaire,
            singleSchedule: localUser.singleSchedule,
            plan: localUser.planId,
            step: localUser.step,
            stepStatus: localUser.stepStatus,
            stepDescription: localUser.stepStatusDescription
          }
        }
      });
    }
  };

  useEffect(() => {
    dispatch(GetListDependents());

    dispatch({
      type: IS_USER_DATA_STALE,
      state: {
        isUserDataStale: true
      }
    });
  }, []);

  useEffect(() => {
    localStorageToRedux();

    dispatch({
      type: IS_USER_DATA_STALE,
      state: {
        isUserDataStale: false
      }
    });
  }, [isUserDataStale]);

  const renderResultCard = (isMobile: boolean): ReactElement => {
    if (user.plan === 1) {
      if (user.questionnaire) {
        return (
          <MiniCard img={QuizImg} buttonText="Ver Resultados" isLink="/historic">
            <p>Veja o resultado <br /> dos seus exames</p>
          </MiniCard>
        );
      }
      return (
        <MiniCard img={QuizImg} buttonText="Responder" isLink="/questionario">
          <p>Responda ao questionário para completar seu perfil</p>
        </MiniCard>
      );
    }

    if (user.questionnaire) {
      if (isMobile) {
        return (
          <Card
            mode="light"
            img={ResultsImg}
            cardBody={
              <span>
                {' '}
                Acompanhe o resultado dos seus <b>exames</b>.
              </span>
            }
            buttonText="Ver Histórico"
            imgHeight={70}
            isLink="/historic"
          />
        );
      }
      return (
        <Card
          mode="light"
          img={ResultsImg}
          cardBody={
            <span>
              Por aqui você pode acompanhar o <br /> resultado de seus
              exames.
            </span>
          }
          cardBodyText=""
          buttonText="Ver Histórico"
          isRightImg
          isLink="/historic"
        />
      );
    }

    return (
      <MiniCard img={QuizImg} buttonText="Responder" isLink="/questionario">
        <p style={isMobile ? { fontSize: '13.5px' } : undefined}>
          Responda ao questionário para completar seu perfil
        </p>
      </MiniCard>
    );
  };

  return (
      <ContentHome>
        {showDesktopComponent ? (
          <>
            <ContactNurse open={contactNurse} setOpen={setContactNurse} />
            <ContentLayout plan={user.plan === 1 ? 'one' : 'infinity'}>
              <Nurse>
                <Card
                  mode="dark"
                  img={NurseImg}
                  cardBody="Bem-vindo, "
                  userName={`${user.firstName} ${user.lastName}`}
                  buttonText="Falar com o Enfermeiro"
                  onClick={setContactNurse}
                />
              </Nurse>
              <Result>
                {renderResultCard(false)}
              </Result>
              {/* É exibida a opção de consulta avulsa caso o plano do usuário seja do tipo One */}
              <History>
                <Historic reverse />
              </History>
            </ContentLayout>
            <Sidebar>
              <Schedule />
              <HelpCenter
                title="Central de Ajuda"
                callCenter="551136202550"
                email="einsteinconecta@einstein.br"
                img={HelpImage}
              />
            </Sidebar>
          </>
        ) : (
          <>
            <ContactNurse open={contactNurse} setOpen={setContactNurse} />
            <ContentLayout plan={user.plan === 1 ? 'one' : 'infinity'}>
              <ServicesWrapper>
                <Slider settings={settings}>
                  <Nurse>
                    <Card
                      mode="dark"
                      img={NurseImg}
                      cardBody="Bem-vindo, "
                      userName={`${user.firstName} ${user.lastName} `}
                      cardBodyText=""
                      buttonText="Falar com o Enfermeiro"
                      onClick={setContactNurse}
                      imgHeight={70}
                    />
                  </Nurse>
                  <Result>
                    {renderResultCard(true)}
                  </Result>
                </Slider>
              </ServicesWrapper>
              <History>
                <Historic reverse />
              </History>
              <Schedule />
            </ContentLayout>
          </>
        )}
      </ContentHome>
  );
}
